module.exports = __webpack_public_path__ + "static/media/v15.af4c1cc8.png";